import type { SVGProps } from "react";
export interface VolumeOffIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function VolumeOffIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: VolumeOffIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M22.102 15.995a1.125 1.125 0 0 1-1.975-1.08zm-1.227-3.994c0-2.49-1.525-4.688-3.81-5.753l-.467-.198-.105-.045a1.126 1.126 0 0 1 .8-2.092l.108.037.309.123c3.162 1.339 5.415 4.361 5.415 7.928 0 1.44-.37 2.8-1.023 3.994l-.988-.54-.987-.54a6.05 6.05 0 0 0 .748-2.914m-4 0c0-.328-.138-.681-.459-1.008l-.147-.138-.084-.08a1.125 1.125 0 0 1 1.456-1.7l.09.07.295.277c.659.676 1.099 1.564 1.099 2.579q0 .24-.032.474a1.126 1.126 0 0 1-2.23-.31 1 1 0 0 0 .012-.164m-5-4.657v-3.02l-.883.953-1.65-1.53 1.1-1.186.127-.126c1.333-1.23 3.556-.3 3.556 1.572v3.337a1.125 1.125 0 0 1-2.25 0m-.883-2.067a1.126 1.126 0 0 1-1.65-1.53zm3.132 14.724c0 1.932-2.369 2.861-3.682 1.444l-4.934-5.32H4a3.125 3.125 0 0 1-3.125-3.124v-2.002A3.125 3.125 0 0 1 4 7.875h1.508l.374-.403-3.677-3.677-.078-.085A1.125 1.125 0 0 1 3.71 2.127l.087.078 18 18 .076.085a1.125 1.125 0 0 1-1.582 1.583l-.085-.078-2.065-2.065q-.36.175-.739.32l-.11.036a1.124 1.124 0 0 1-.855-2.06l-2.312-2.311V20Zm-10.999-7c0 .482.392.874.875.874h1.564c.517 0 1.014.189 1.399.526l.158.154 4.753 5.127v-6.217l-4.4-4.4-.353.38c-.402.433-.966.68-1.557.68H4a.875.875 0 0 0-.875.874z"
      />
    </svg>
  );
}
